import { render, staticRenderFns } from "./userSelector.vue?vue&type=template&id=586b1c0c"
import script from "./userSelector.vue?vue&type=script&lang=js"
export * from "./userSelector.vue?vue&type=script&lang=js"
import style0 from "./userSelector.vue?vue&type=style&index=0&id=586b1c0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports